import type { ReactElement } from "react"
import React from "react"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import { seoTextOverrides } from "./markdownOverrides"

interface ProductSeoProps {
  productSeoText: string
}

export default function ProductSeo({
  productSeoText,
}: ProductSeoProps): ReactElement<ProductSeoProps> {
  return (
    <MarkdownText overrides={seoTextOverrides} forceBlock={false}>
      {productSeoText}
    </MarkdownText>
  )
}
